const state = {
    listen: null
}

export default state